  window.onload=function(){
    // $('#prd-faq .block-item').click(function (e) {
    //   $(this).toggleClass('active');
    // })
    if ($('#prd-faq').length > 0) {
      $('#prd-faq-li').removeClass('hide')
    } else {
      $('#prd-faq-li').remove()
    }
    $("#prd-faq .block-item").click(function (event) {
      let _this = $(this);
      if (_this.hasClass("block-item-active")) {
        _this.removeClass("block-item-active");
      } else {
        _this.addClass("block-item-active");
      }

    })


    function Tab(options = {}) {
      this.pageProducts = options.pageProducts || document.querySelector('.product-page-container')
      this.tabNav = this.pageProducts.querySelector('.product-nav-tabs')
      this.tabNavis = this.tabNav.querySelectorAll('.product-nav-tab')
      this.tabContent = this.pageProducts.querySelector('.tab-content')
      this.tabContentis = this.tabContent.querySelectorAll('.tab-pane')
      console.log(this.tabContentis)
      this.init()
    }
    Tab.prototype.init = function () {
      const that = this
      for (let i = 0; i < that.tabNavis.length; i++) {
        that.tabNavis[i].onclick = function () {
          for (let j = 0; j < that.tabNavis.length; j++) {
            that.tabNavis[j].classList.remove("active")
            that.tabContentis[j].classList.add("hide")
          }
          that.tabNavis[i].classList.add("active")
          that.tabContentis[i].classList.remove("hide")
          that.tabContentis[i].classList.add("active")
        }
      }
    }
    new Tab({
      pageProducts: document.querySelector(".product-page-container")
    })
  }
  